__webpack_require__.p = "https://static.schoolobjects.com/182/";